import { useMutation, useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPayrunPayment } from "../models/Payment";
import { DefaultResponseWithData } from "./../models/system";

export default function usePaymentStatus(leadId: string, transactionId: string) {
  const { get } = useApiHelper();

  const paymentStatus = useQuery({
    queryKey: ["paymentStatus", leadId, transactionId],
    queryFn: () =>
      get<DefaultResponseWithData<IPayrunPayment>>(
        `/payment/${leadId}/${transactionId}`
      ),
    enabled: !!leadId && !!transactionId && transactionId !== "00000000-0000-0000-0000-000000000000",
    staleTime: 1000 * 60 * 10, // 10 minutes
  });

  const paymentStatusMutation = useMutation(
    ({ leadId, transactionId }: { leadId: string; transactionId: string }) =>
      get<DefaultResponseWithData<IPayrunPayment>>(
        `/payment/${leadId}/${transactionId}`
      )
  );

  return {
    paymentStatus,
    paymentStatusMutation,
  };
}
